import React, { useState } from 'react';

import { FieldLabel, StyledTextInput } from 'app/src/elements/inputs';
import Modal from 'app/src/elements/Modal';
import { Button, ButtonGroup } from 'app/src/elements/buttons';

export const Counter = ({ feeEstimate, setShowModal, updateFeeEstimate }) => {
  const [counterAmount, setCounterAmount] = useState('');
  const saveCounter = () => {
    updateFeeEstimate(
      { variables:
        {
          id: parseInt(feeEstimate.id),
          status: 'Countered',
          counterAmount: parseFloat(counterAmount),
          activeFor: 'User'
        }
      }
    );
  };

  return (
    <Modal
      showModal
      setShowModal={setShowModal}
      modalType={feeEstimate.asset.stockNumber}
      objectName={feeEstimate.asset.name}
    >
      <FieldLabel label="Fee Estimate Counter Amount" />
        <StyledTextInput
          onChange={e => setCounterAmount(e.target.value)}
          value={counterAmount || ''}
        />
      <ButtonGroup>
        <Button label="Update" onPress={saveCounter} />
      </ButtonGroup>
    </Modal>
  );
};

export default Counter;
